import { render, staticRenderFns } from "./Comnt&Student.vue?vue&type=template&id=15359723&scoped=true"
import script from "./Comnt&Student.vue?vue&type=script&lang=js"
export * from "./Comnt&Student.vue?vue&type=script&lang=js"
import style0 from "./Comnt&Student.vue?vue&type=style&index=0&id=15359723&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15359723",
  null
  
)

export default component.exports